export const LIGHT_THEME_LINK = "#335DF5";

export const DARK_THEME_LINK = "#335DF5";
